export default __webpack_public_path__ + "static/media/fiveDerps.716206be.gif";